<div class="col-lg-12 p-0 m-0">
    <div class="row p-0 m-0">
        <div class="col-lg-6 p-0 m-0">
            <div>
                <span class="date-picker-label-font">Uploaded Between</span>
            </div>
            <mat-form-field appearance="outline">
                <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                    <input matStartDate formControlName="startDate" placeholder="Start date">
                    <input matEndDate formControlName="endDate" placeholder="End date"
                        (dateChange)="compareDocumentSelectedDates()">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </div>
        <div class="col-lg-6 p-0 m-0 filter-space" *ngIf="filterBy">
            <p class="filtered-text"><span *ngIf="showfilterBy">Filtered by: </span>
                <ng-container *ngFor="let opt of filterBy | keyvalue; let last = last;"> 
                    <span *ngIf="!last && opt.key!=='uploadedOn'">[{{opt.key}}: {{filterBy[opt.key].filter}}], </span>
                    <span *ngIf="last && opt.key!=='uploadedOn'">[{{opt.key}}: {{filterBy[opt.key].filter}}]</span>
                    <span *ngIf="!last && opt.key==='uploadedOn'">[{{opt.key}}: {{filterBy[opt.key].filter}}], </span>
                    <span *ngIf="last && opt.key==='uploadedOn'">[{{opt.key}}: {{filterBy[opt.key].dateFrom | date:
                        'MM/dd/yyyy'}} {{filterBy[opt.key].dateTo| date: 'MM/dd/yyyy'}}]</span>
                </ng-container>
                <span (click)="clearFilter($event)" style="cursor: pointer;">
                    <span class="material-icons-outlined" [tooltip]="template1" contentType="template"
                        [options]="tooltipOptions" tooltipClass="tooltip-feedback">
                        <mat-icon class="filter-alt-icon">filter_alt</mat-icon>
                        <mat-icon class="clear-icon">clear</mat-icon>
                    </span>
                    <ng-template #template1 class="w-100">
                        <div class="row mx-0 w-100">
                            <div class="col-12 w-100 px-0">
                                <span>Clear all filters</span>
                            </div>
                        </div>
                    </ng-template>
                </span>
            </p>
        </div>
    </div>
</div>

<div id="document-grid-container" class="share-document-search-grid">
    <ag-grid-angular style="height: 624px !important;" [gridOptions]="gridOptions"
        class="document-search-grid sg-document-search-grid sg-header-cell-overflow ag-theme-alpine mb-5 sg-documents-table document-grid"
        [columnDefs]="columnDefs" [animateRows]="true" [defaultColDef]="defaultColDef" [pagination]="true"
        [paginationPageSize]="paginationPageSize" [cacheBlockSize]="cacheBlockSize"
        (gridReady)="populateGridData($event)" [rowData]="rowData" [floatingFilter]=" true"
        [frameworkComponents]="editDownloadIcon" (firstDataRendered)="onFirstDataRendered()"
        (filterChanged)="onFilterChanged($event)"
        >
    </ag-grid-angular>
</div>